export function loadingSpinner(args) {
    args = args || {};
    var top = args.top || "100px",
        fillSpace = (args.fillSpace || args.fillSpace == undefined) ? "fill-space" : "",
        overlay = args.overlay ? "k-overlay" : "";
    return '<div class="k-loading-mask ' + fillSpace + " " + overlay + '">' +
        '<div class="k-loading-image_2x" style="top: ' + top + '; position: relative;"></div></div>';
}
